// extracted by mini-css-extract-plugin
export var cancelButton = "_lw-5";
export var content = "_lw-3";
export var createButton = "_lw-6";
export var drawerContainer = "_lw-0";
export var footer = "_lw-2";
export var header = "_lw-1";
export var orderFormColumn = "_lw-4";